<div class="cart-header">
      <h3>{{ 'cart.title' | optimizedI18n }}</h3>
  <fa-icon [icon]="faX" class="icon-close" (click)="toggleCart()"></fa-icon>
</div>

<div class="cart-items-cart" *ngIf="cartItems.length === 0">
  <div>
    <img src="/assets/img/shopping-bag.svg" alt="Carrito vacio" />
  </div>
  <div>
        <h4>
          {{ 'cart.empty' | optimizedI18n }}
        </h4>
  </div>
  <div>
    <button class="buy-button" (click) = "goHome()">
      {{ 'btn.continue_shopping' | optimizedI18n }}
    </button>
  </div>
</div>

<div class="cart-items" *ngIf="cartItems.length > 0">
  <div *ngFor="let item of cartItems" class="cart-item" [id] = "item._id" #cartItem>
    <div class="cart-item-image-container">
      <img [src]="item.image" alt="{{ item.name }}" class="cart-item-image" />
    </div>

    <div class="cart-item-details">
      <div class="name-and-price-container">
        <h4 class="nameProduct" [routerLink] = "'/home/detail-product/' + item._id">{{ item.name }}</h4>
        <h4
          class="priceProduct"
          [ngClass]="{ discounted: (item?.previousPrice || 0) > 0 }"
        >
          {{ formatCurrency(item.price) }}
          <p class="previousPrice" *ngIf="(item?.previousPrice || 0) > 0">
            {{ formatCurrency(item.previousPrice) }}
          </p>
        </h4>
      </div>

      <div *ngIf="item.color || item.size" class="size-or-color-container">
        <div>
          <p class="sizeOrColor" *ngIf="item.size || item.color">
            <span *ngIf="item.size">Talla {{ item.size }}</span>
            <span *ngIf="item.size && item.color"> / </span>
            <span *ngIf="item.color">Color {{ item.color }}</span>
          </p>
        </div>
        <div></div>
      </div>

      <div class="quantity-container">
        <div>
          <button
            (click)="decreaseQuantity(item)"
            class="quantity-btn"
            [disabled]="item.quantity <= 1"
          >
            <fa-icon [icon]="faMinus" class="faMinus"></fa-icon>
          </button>
          <input
              type="text"
              [(ngModel)]="item.quantity"
              min="1"
              class="input-counter"
              (ngModelChange)="validateQuantity(item)"
              pattern="[0-9]*"
              (keypress)="onlyNumbers($event)"
          />
          <button
            (click)="increaseQuantity(item)"
            class="quantity-btn"
            [disabled]="
              item.quantity >= item.maxQuantity || item.quantity == null
            "
          >
            <fa-icon [icon]="faPlus" class="faPlus"></fa-icon>
          </button>
        </div>

        <div>
          <span (click)="removeItem(item)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M10 11V17M14 11V17"
                stroke="#A40E21"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="cart-footer" *ngIf="cartItems.length > 0">
  <div class = "values-container">
    <h4>
          <span>{{ 'cart.subtotal' | optimizedI18n }}:</span>
      <span class="amount">{{ formatCurrency(subtotalAmount) }}</span>
    </h4>
    <h4>
      <span>{{ 'cart.discount' | optimizedI18n }}:</span>
      <span class="amount">{{ (totalDiscount > 0 ? "-" : '') + formatCurrency(totalDiscount) }}</span>
    </h4>
    <h4>
      <span>{{ 'cart.total' | optimizedI18n }}:</span>
      <span class="amount">{{ formatCurrency(totalAmount) }}</span>
    </h4>
  </div>
  
  <div class = "actions-container">
    <button
    class="clear-cart-btn"
    (click)="clearCart()"
    [disabled]="cartItems.length === 0"
  >
        {{ 'btn.clear' | optimizedI18n }}
  </button>
  <button
    class="buy-button"
    (click)="checkout()"
    [disabled]="cartItems.length === 0"
  >
        {{ 'btn.proceed_to_checkout' | optimizedI18n }}
  </button>
  </div>
  
</div>
